import { render } from "./SliderContainer.vue?vue&type=template&id=a229d19e"
import script from "./SliderContainer.vue?vue&type=script&lang=js"
export * from "./SliderContainer.vue?vue&type=script&lang=js"

import "./SliderContainer.vue?vue&type=style&index=0&id=a229d19e&lang=scss"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__